import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaPiggyBank, FaClock, FaShieldAlt, FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./FeatureCardsSection.css";

export default function FeatureCardsSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const features = [
    {
      icon: <FaPiggyBank className="feature-icon" />,
      title: t("featureCards.compare.title"),
      subtitle: t("featureCards.compare.subtitle"),
      description: t("featureCards.compare.description"),
    },
    {
      icon: <FaClock className="feature-icon" />,
      title: t("featureCards.fast.title"),
      subtitle: t("featureCards.fast.subtitle"),
      description: t("featureCards.fast.description"),
    },
    {
      icon: <FaShieldAlt className="feature-icon" />,
      title: t("featureCards.verified.title"),
      subtitle: t("featureCards.verified.subtitle"),
      description: t("featureCards.verified.description"),
    },
    {
      icon: (
        <div className="rating-icon">
          <FaStar className="feature-icon" />
          <FaStar className="feature-icon" />
          <span className="rating-value">4,8/5</span>
        </div>
      ),
      title: t("featureCards.trusted.title"),
      subtitle: t("featureCards.trusted.subtitle"),
      description: t("featureCards.trusted.description"),
    },
  ];

  const handleStartRequest = () => {
    // Scroll to the transport form or navigate
    const formSection = document.getElementById("bookingFormSection");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section className="feature-cards-section">
      <Container>
        <Row className="g-4 justify-content-center">
          {features.map((feature, index) => (
            <Col   xs={12}
              sm={6}
              md={6} // 👈 2 كروت بس في التابلت بدل 4
              xl={3} // 👈 4 كروت في الديسكتوب
              key={index}
            >
              <div className="feature-card">
                <div className="feature-card-icon">
                  {feature.icon}
                </div>
                <div className="feature-card-content">
                  <h3 className="feature-card-title">{feature.title}</h3>
                  {feature.subtitle && (
                    <p className="feature-card-subtitle">{feature.subtitle}</p>
                  )}
                  <p className="feature-card-description">{feature.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        <div className="text-center mt-5">
          <Button
            className="text-white cta-button-glow"
            onClick={handleStartRequest}
          >
            {t("featureCards.ctaButton")} →
          </Button>
        </div>
      </Container>
    </section>
  );
}
